export default "__VITE_ASSET__BJDtk21I__"